export interface ICloseX {
  className?: string;
  fill?: string;
  size?: number;
  title?: string;
}

export const CloseX = ({ className, fill, size, title = 'Close (X)' }: ICloseX) => {
  return (
    <svg
      className={className}
      width={size || '8'}
      height={size || '8'}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path d="M1 1L7 7" stroke={fill || 'black'} />
      <path d="M7 1L1 7" stroke={fill || 'black'} />
    </svg>
  );
};
